export default "__VITE_ASSET__5hiC0_NL__"